import React, { useEffect, useState } from "react";
import { brandCode, getBrandLogoColor } from "./brand-presentation.js";

export default function BrandLabel({ brand }) {
  const [failed, setFailed] = useState(false);
  const url = brand.logo_url || "";
  useEffect(() => setFailed(false), [url]);
  if (url && !failed)
    return (
      <img
        className="brand-logo"
        src={url}
        alt={brand.name}
        onError={() => setFailed(true)}
      />
    );
  return (
    <span
      className={`brand-wordmark brand-${brandCode(brand)}`}
      style={{ color: getBrandLogoColor(brand) }}
    >
      {brand.name}
    </span>
  );
}
